import React from 'react';
import { connect } from 'react-redux';
import Icon from '@components/@core/Icon';
import Pagination from '@components/@core/Pagination';
import AppActions from '~/actions/app';
import CommunityActions from '~/actions/community';
import withNavigate from '~/hocs/withNavigate';
import { ForumDepartmentIcons } from '~/services/config';
import CommunityHeader from '~/views/Community/Community/Header';
import TopicList from './TopicList';

class DepartmentFeed extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            departmentId: props.params?.departId,
            page: 1,
            perPage: 10,
        };
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        this.handleGetTopics();
    }

    handleGetTopics = () => {
        const { departmentId, page, perPage } = this.state;
        this.props.getTopics({ category_id: departmentId, order: 'recent', page, per_page: perPage });
    };

    handlePagination = (page) => {
        this.setState({ page }, () => this.handleGetTopics());
    };

    handlePer = (perPage) => {
        this.setState({ perPage }, () => this.handleGetTopics());
    };

    handleAddForum = () => {
        const after = { type: 'GETBLOGCATEGORIES_REQUEST' };
        this.props.toggleModal({
            type: 'Add Forum',
            data: { before: { after } },
            callBack: this.handleGetTopics,
        });
    };

    render() {
        const { departments, topics } = this.props;
        const { departmentId } = this.state;
        const departmentData = departments?.filter((item) => item.id == departmentId)[0] || [];
        const data = topics[departmentId]?.topics;

        return (
            <div className="community-forum">
                <CommunityHeader activeRoute="Forums" childRoute={departmentData.name} backTitle="all forums" onBack={() => this.props.navigateBack()} onModal={this.handleAddForum} />
                <div className="card mb-2">
                    <div className="dsl-b22 bold category-title">{departmentData.name}</div>
                    <div>
                        <div className="d-h-start mt-2 pb-2 desktop-screen">
                            <div className="d-flex-3">
                                <span className="dsl-m12 text-400">Department</span>
                            </div>
                            <div className="d-flex-1 text-end">
                                <span className="dsl-m12 text-400"># posts</span>
                            </div>
                            <div className="d-flex-1" />
                            <div className="d-flex-3">
                                <span className="dsl-m12 text-400">Stats</span>
                            </div>
                            <div className="d-flex-4">
                                <span className="dsl-m12 text-400">Latest Post</span>
                            </div>
                        </div>
                        <div className="d-flex ssm-column ai-center ssm-ai-start pb-2">
                            <div className="d-flex-3 d-h-start py-2 py-sm-0">
                                <Icon name={ForumDepartmentIcons[departmentData.id]} size={13} color="#969faa" className="mr-3" />
                                <span className="dsl-b16 ms-2">{departmentData.name}</span>
                            </div>
                            <div className="d-flex-1 text-end ssm-left w-100">
                                <label className="dsl-b14 mobile-screen w-30">Posts</label>
                                <span className="dsl-b16">{departmentData?.data?.stats?.blog_posts_abbr}</span>
                            </div>
                            <div className="d-flex-1" />
                            <div className="d-flex-3 d-flex w-100">
                                <div className="d-flex ai-center w-auto py-2">
                                    <Icon name="far fa-eye me-2 ssm-r-0 text-500" size={12} color="#969faa" />
                                    <span className="dsl-d14 me-3 text-400 ps-1">{departmentData?.data?.stats?.forum__views_abbr}</span>
                                </div>
                                <div className="d-flex ai-center w-auto py-2">
                                    <Icon name="fas fa-thumbs-up me-2 ssm-r-0 text-500" size={12} color="#969faa" />
                                    <span className="dsl-d14 me-3 text-400 ps-1">{departmentData?.data?.stats?.forum_discussions}</span>
                                </div>
                                <div className="d-flex ai-center w-auto py-2">
                                    <Icon name="far fa-comment me-2 ssm-r-0 text-500" size={12} color="#969faa" />
                                    <span className="dsl-d14 text-400 ps-1">{departmentData?.data?.stats?.blog__comments_abbr}</span>
                                </div>
                            </div>
                            <div className="d-flex-4 truncate-one py-2 py-sm-0">
                                <span className="dsl-b16">{departmentData?.latest[0]?.name}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="card">
                    <div className="d-flex mb-4 category-title">
                        <div className="dsl-b22 bold d-flex-4">Recent Topics</div>
                        <div className="dsl-p14 text-400 me-2 cursor-pointer" onClick={this.handleAddForum}>
                            ADD TOPIC
                        </div>
                    </div>
                    <TopicList data={data?.data} departmentId={departmentId} departmentName={departmentData.name} />
                    <Pagination className="p-0" current={data?.current_page} pers={[10, 20, 'all']} total={Math.ceil(data?.last_page)} onChange={this.handlePagination} onPer={this.handlePer} />
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    departments: state.company.blogCategories,
    topics: state.community.topics,
});

const mapDispatchToProps = (dispatch) => ({
    getTopics: (e) => dispatch(CommunityActions.gettopicsRequest(e)),
    toggleModal: (e) => dispatch(AppActions.modalRequest(e)),
});

const DepartmentFeedWithNavigate = withNavigate(DepartmentFeed);

export default connect(mapStateToProps, mapDispatchToProps)(DepartmentFeedWithNavigate);
